export default __webpack_public_path__ + "static/media/daily-weight-logger.a6dfaae6.png";